import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setActiveTab } from '../../redux/slices/header-slice.js';
import SubLinks from '../../components/header/SubLinks.jsx';
import { adminLinks } from '../../config/standard-links.js';
import UserDataTransferForm from '../../components/admin-automations/UserDataTransferForm.jsx';
import UserRemovalForm from '../../components/admin-automations/UserRemovalForm.jsx';
import BackArrow from '../../components/common/BackArrow.jsx';

/**
 * Component for rendering the User Removal Automation page.
 * @returns {JSX.Element} User Removal Automation page component.
 */
const UserRemovalPage = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setActiveTab('Admin'));

        return () => {
            dispatch(setActiveTab(null));
        };
    });

    return (
        <div>
            <SubLinks links={adminLinks} />
            <div className="newsc-container">
                <br />
                <br />
                <br />
                <div className="create-office-heading">
                    <BackArrow navigateTo={-1} />
                    <h2>User Removal Automation</h2>
                </div>
                <br />
                <br />
                <br />
                <UserDataTransferForm />
                <br />
                <br />
                <UserRemovalForm />
            </div>
        </div>
    );
};

export default UserRemovalPage;
